import type { IAccountant } from 'types/accountant.types';
import useGetExpertLoggedInUserData from './useGetExpertLoggedInUserData';

type AuthAccountantStatusType = {
  isAuthenticated: boolean;
  isLoadingAuthData: boolean;
  accountant: IAccountant | undefined;
};

/**
 * Expert-specific auth status hook
 * Uses expert auth data structure and accountant data
 */
const useAuthAccountantStatus = (): AuthAccountantStatusType => {
  const { data: accountant, isLoading } = useGetExpertLoggedInUserData();

  return {
    isAuthenticated: !!accountant,
    isLoadingAuthData: isLoading,
    accountant,
  };
};

export default useAuthAccountantStatus;
